export const QueryKey = {
	content: 'content',
	productTypes: 'productTypes',
	defaultVariants: 'defaultVariants',
	productDefinition: 'productDefinition',
	productSpecification: 'productSpecification',
	creatorSettings: 'creatorSettings',
	configuratorTemplates: 'configuratorTemplates',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
